"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _default = (0, _keyMirror.default)({
  DYNAMIC_FORM_REQUESTED: null,
  DYNAMIC_FORM_FETCHED: null,
  DYNAMIC_FORM_FETCH_FAILED: null,
  FORM_SUBMISSION_FAILED: null,
  FORM_SUBMISSION_REQUESTED: null,
  FORM_SUBMITTED: null,
  INSTANCE_FETCHED: null,
  INSTANCE_FETCH_FAILED: null,
  INSTANCE_REQUESTED: null
});

exports.default = _default;
module.exports = exports.default;